import { CopyOutlined } from "@ant-design/icons";
import { TagField, TextField } from "@refinedev/antd";
import { ConfigProvider, Modal, Popover, Row, Typography, message } from "antd";
import React from "react";

type ShowApiKeyModalProps = {
	apiKey: string;
	open: boolean;
	onClose: () => void;
};
export const ShowApiKeyModal: React.FC<ShowApiKeyModalProps> = ({
	apiKey,
	open,
	onClose,
}) => {
	return (
		<ConfigProvider
			theme={{
				token: {
					colorBgBase: "#1A1D38",
				},
				components: {
					Modal: {
						contentBg: "#1A1D38",
						colorText: "#fff",
					},
				},
			}}
		>
			<Modal
				open={open}
				onOk={() => {
					navigator.clipboard.writeText(apiKey);
					message.success("API key copied successfully");
				}}
				onCancel={() => {
					onClose();
				}}
				okText={"Copy to clipboard"}
				cancelText={"Close"}
				closable={true}
				title={"Generated API Key"}
			>
				<Typography>
					Please copy the API key. You will not be able to see the API
					key again.
				</Typography>
				<TagField value={apiKey} />
			</Modal>
		</ConfigProvider>
	);
};
